import {areaCache} from "../lib/cache";
import {timeMixin} from "../mixins/time";
import {DateCache} from "../lib/cache";
import {DocCache} from "../lib/cache";
import {HosCache} from "../lib/cache";
import {OnlineHosCache} from "../lib/cache";
import {SelectedHosCache} from "../lib/cache";
import {bookService} from "../services/book";

export const cacheMixin = {
  mixins: [timeMixin],
  async created () {
    await this.getDateCache()
  },
  methods:{
    /**
     * 获取缓存日期
     * 每天只请求一次版本号接口
     **/
    async getDateCache () {
      let oldDate = DateCache.get()
      let newDate = this.mixin_time_get_today()
      //一天只查询一次
      if (oldDate !== newDate){
        this.getAreaVersion(oldDate, newDate)
        this.getDocCacheVersion(oldDate, newDate)
        this.getAreaHosList()
      }
    },

    /**
     * 获取多医院信息
     **/
    async getAreaHosList() {
      let list = await bookService.areaHosList()
      let o = {}
      list.forEach(item => {
        let key = item.yyid
        let value = item
        o[key] = value
      })
      HosCache.set(o)
    },
    /**
     * 获取地区列表缓存版本号
     * @param oldDate
     * @param newDate
     **/
    async getAreaVersion (oldDate, newDate) {
      let GbArea = areaCache.get()
      let oldVersion = GbArea? GbArea.version : null
      let newVersion
      let {code, obj} = await this.$http('smarthos.system.area.list.version')
      code=='0' && (newVersion = obj)
      if (oldVersion !== newVersion) {
        this.setArea(oldDate, newDate, newVersion)
      }
    },

    /**
     * 地区列表缓存
     * @param oldDate
     * @param newDate
     * @param newVersion
     **/
    async setArea (oldDate, newDate, newVersion) {
      let {code, obj} = await this.$http('smarthos.system.area.list.third')
      if (code == '0') {
        areaCache.set(obj, newVersion)
        DateCache.set(newDate)
      } else {
        DateCache.set(oldDate)
      }
    },

    /**
     * 获取缓存医生版本号
     * @param oldDate
     * @param newDate
     * @returns {Promise<void>}
     */
    async getDocCacheVersion (oldDate, newDate) {
      let DOC_CACHE = localStorage.getItem('DOC_CACHE')
      let docCache = DOC_CACHE? DocCache.get() : null
      let oldVersion = docCache && docCache.version
      let {code, obj} = await this.$http('smarthos.user.doc.cache.version')
      if (code == '0') {
        oldVersion !== obj && this.getDocListCacheVersion(oldDate, newDate, obj)
      }
    },

    /**
     * 获取缓存医生列表
     * @param oldDate
     * @param newDate
     * @param newVersion
     * @returns {Promise<void>}
     */
    async getDocListCacheVersion (oldDate, newDate, newVersion) {
      let {code, list} = await this.$http('smarthos.user.doc.cache.list')
      if (code == '0') {
        let obj = {
          version:newVersion,
          list: list
        }
        DocCache.set(obj)
        DateCache.set(newDate)
      } else {
        DateCache.set(oldDate)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/cache.js